/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  trackMessageImpression.js
 */

import { selectIsMobile } from '@zcode-ui/web-zumper-global-state'
import { MESSAGE_IMPRESSION, event, getEntityProperties } from '@zcode-ui/web-zumper-integrations'
import { Origin } from '@zcode/nr-utils'
import { selectUser } from '@zcode/nr/es/shared/modules/user/selectors'
import { getRouteProps } from '@zcode/nr/es/shared/packages/history-middleware'
import type { Listable, MaybeEmptyProperty, Pin, RawPinInventorySearch } from '@zcode/state-type'
import { routes } from '@zcode/zumper-routes'
import type { Dispatch, GetState } from '../../../modules/types'
import { getTraktorPageType } from './trackDetailEvent'

interface Props {
  contactFormAction?: string
  ctaName?: string
  entity: Listable | Pin<RawPinInventorySearch> | MaybeEmptyProperty | null | undefined
  origin: Origin
}

export const trackMessageImpression =
  ({ entity, origin, contactFormAction, ctaName }: Props) =>
  (dispatch: Dispatch, getState: GetState) => {
    if (!entity) {
      return
    }
    const state = getState()
    const isMobile = selectIsMobile(state)
    if (
      (!isMobile && (origin === Origin.DETAIL_INLINE || origin === Origin.ADDR_DETAIL_INLINE)) ||
      (
        [
          Origin.CAROUSEL_FROM_DETAIL,
          Origin.DETAIL_MOBILE_BOTTOM,
          Origin.ADDR_DETAIL_MOBILE_BOTTOM,
          Origin.DETAIL_MOBILE_STICKY,
          Origin.ADDR_DETAIL_MOBILE_STICKY,
          Origin.LIST_ITEM,
        ] as Origin[]
      ).includes(origin)
    ) {
      const user = selectUser(state)
      const entityProperties = getEntityProperties(entity, state)
      const { match } = dispatch(getRouteProps({ routes }))
      const props = {
        origin,
        ...entityProperties,
        contactFormAction,
        ctaName,
        pageType: getTraktorPageType(entity, match, state),
      }
      dispatch(event({ name: MESSAGE_IMPRESSION, user, props }))
    }
  }
